import { Pipe, PipeTransform } from '@angular/core';
import { AssessmentReportingType } from '../../multi-stage-growth-report/models/multi-stage-growth-report.model';
import { AssessmentReportingTypeLabels } from '../models/common.model';

@Pipe({
  name: 'assessmentReportingTypeLabel',
})
export class AssessmentReportingTypeLabel implements PipeTransform {
  transform(reportingType: AssessmentReportingType): string {
    switch (reportingType) {
      case AssessmentReportingType.BOY:
        return AssessmentReportingTypeLabels.BOY;
      case AssessmentReportingType.MOY:
        return AssessmentReportingTypeLabels.MOY;
      case AssessmentReportingType.EOY:
        return AssessmentReportingTypeLabels.EOY;
      default:
        return '';
    }
  }
}
